import api from './api';
import * as types from './mutation-types';

export default {
	getPlant_({ commit }) {
		return api
			.getPlant_()
			.then(data => {
				if (data.header.code === 0) {
					let body = data.body;
					body.map((object, index) => {
						(object.value = object.commCd), (object.label = object.commCdName);
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'plants',
						value: body
					});
				}
				return data.header;
			})
			.catch(error => {
				throw error;
			});
	},
	getCommCds_({ commit, state }, { commCdType, commCdList, option }) {
		return api
			.getCommCds_({ plantCd: state.plantCd, commCdType: commCdType })
			.then(data => {
				if (data.header.code === 0) {
					let body = data.body;
					body.map((object, index) => {
						(object.value = object.commCd), (object.label = object.commCdName);
					});
					body.unshift({ value: option, label: option });
					commit(types.DEFAULT_ASSIGN, {
						key: commCdList,
						value: body
					});
				}
				return data.header;
			})
			.catch(error => {
				throw error;
			});
	},
	getQueueRecordCountList_({ commit, state }) {
		return api
			.getQueueRecordCountList_({
				plantCd: state.plantCd,
				queueType: state.queueType,
				remained: state.remained
			})
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'queueRecordCountList',
						value: data.body.resultList
					});
				}
				return data.header;
			})
			.catch(error => {
				throw error;
			});
	}
};
